import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {
	ExamBookingEnum,
	HealthBookingEnum,
	OdontoBookingEnum,
	TelehealthBookingEnum,
} from 'presentation/constants';
import IconNamesType from 'presentation/icons/IconNamesType';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {ServicesTypesEnum} from 'presentation/pages/private/services/types';
import {translations} from 'presentation/translations-new';
import {BuildAppointmentTypesParams} from './types';

const {selectAppointmentTypeModal} = translations['pt-br'].privateFlow.myAppointments;

export function buildAppointmentTypes({
	hideTelehealth,
	hideHealth,
	hideOdonto,
	hideExam,
}: BuildAppointmentTypesParams) {
	return [
		{
			icon: 'remember-me-filled' as IconNamesType,
			title: selectAppointmentTypeModal.telehealth,
			route: TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW,
			hasEmphasis: true,
			hidden: hideTelehealth,
			serviceType: ServicesTypesEnum.TELEHEALTH,
			dataTagId: AppointmentBookingEnum.CLICK_TELECONSULTA,
			dataTestId: BookingTypeEnum.TELEHEALTH,
		},
		{
			icon: 'stethoscope' as IconNamesType,
			title: selectAppointmentTypeModal.health,
			route: HealthBookingEnum.HEALTH_BOOKING_FLOW,
			hasEmphasis: false,
			hidden: hideHealth,
			serviceType: ServicesTypesEnum.HEALTH,
			dataTagId: AppointmentBookingEnum.CLICK_AGENDAR_CONSULTA,
			dataTestId: BookingTypeEnum.HEALTH,
		},
		{
			icon: 'tooth-outline' as IconNamesType,
			title: selectAppointmentTypeModal.odonto,
			route: OdontoBookingEnum.ODONTO_BOOKING_FLOW,
			hasEmphasis: false,
			hidden: hideOdonto,
			serviceType: ServicesTypesEnum.ODONTO,
			dataTestId: BookingTypeEnum.ODONTO,
		},
		{
			icon: 'needle' as IconNamesType,
			title: selectAppointmentTypeModal.exam,
			route: ExamBookingEnum.EXAM_BOOKING_FLOW,
			hasEmphasis: false,
			hidden: hideExam,
			serviceType: ServicesTypesEnum.EXAMS,
			dataTagId: AppointmentBookingEnum.CLICK_AGENDAR_EXAME,
			dataTestId: BookingTypeEnum.EXAM,
		},
	].filter(el => !el.hidden);
}
